
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonials from './TestimonialKeyword';

function Coproratecabandbusserviceinamravati() {



    const cardData =
    {
        keyword: 'Corporate Cab and Bus Service in Amravati',
        heading: 'etravo :  Corporate Cab and Bus Service in Amravati',
        headingDescription: 'eTravo delivers professional Corporate Cab and Bus Services in Amravati, tailored for businesses seeking reliable and efficient transportation. Whether it’s executive cabs for business meetings or well-maintained buses for staff transfers and corporate outings, we ensure timely, safe, and comfortable travel. Our fleet is optimized for corporate use with experienced chauffeurs, real-time tracking, and business-friendly features. Trust eTravo for seamless corporate mobility solutions in Amravati — designed to support your organization’s travel needs with precision.',

        top: 'Top Places to Visit in Amravati with etravo',

       "topPlaces": [
    {
      "title": "Ambadevi Temple",
      "description": "Located in the heart of Amravati, the Ambadevi Temple is an ancient shrine dedicated to Goddess Amba. According to legend, it is the site where Lord Krishna abducted Rukmini before her wedding. The temple is especially vibrant during Navratri, attracting numerous devotees."
    },
    {
      "title": "Shri Ekvira Devi Temple",
      "description": "Situated near the Ambadevi Temple, Shri Ekvira Devi Temple is another significant religious site in Amravati. Dedicated to Goddess Ekvira, it is known for its spiritual ambiance and is frequented by pilgrims seeking blessings."
    },
    {
      "title": "Melghat Tiger Reserve",
      "description": "Established in 1973 under Project Tiger, Melghat Tiger Reserve spans over 2,768 square kilometers in the Satpura range. It is home to diverse wildlife, including tigers, leopards, sloth bears, and various bird species, making it a haven for nature enthusiasts."
    },
    {
      "title": "Chikhaldara Hill Station",
      "description": "The only hill station in the Vidarbha region, Chikhaldara offers a cool climate, coffee plantations, and scenic viewpoints like Bhimkund, Devi Point, and Vairat Point. It's a perfect getaway for those seeking tranquility amidst nature."
    },
    {
      "title": "Gugamal National Park",
      "description": "Part of the Melghat Tiger Reserve, Gugamal National Park covers an area of 1,673.93 square kilometers. The park boasts dry deciduous forests and is rich in flora and fauna, including teak trees, tigers, and various deer species."
    },
    {
      "title": "Gawilgarh Fort",
      "description": "Perched on the Satpura range, Gawilgarh Fort is a historic fortress built in the 15th century by the Gond kings. The fort offers panoramic views and houses ancient structures like mosques and water tanks, reflecting its rich past."
    },
    {
      "title": "Wadali Talao",
      "description": "Wadali Talao is a serene lake located on the outskirts of Amravati. Surrounded by a garden and a zoo, it's a popular spot for picnics and leisurely walks, offering a peaceful environment away from the city's hustle."
    },
    {
      "title": "Bamboo Garden",
      "description": "Situated near Wadali Talao, the Bamboo Garden showcases various bamboo species and promotes eco-tourism. It's an educational and recreational spot, ideal for families and nature lovers."
    },
    {
      "title": "Upper Wardha Dam",
      "description": "Constructed on the Wardha River, the Upper Wardha Dam is a significant water reservoir. The dam area is known for its scenic beauty, attracting visitors for picnics and bird-watching, especially during the monsoon season."
    },
    {
      "title": "Satidham Temple",
      "description": "Located in the heart of Amravati, Satidham Temple is a modern temple complex housing idols of various deities. The temple is known for its spiritual ambiance and architectural beauty, drawing devotees and tourists alike."
    }
  ],

       "services": [
    {
      "name": "Corporate Travel Solutions Amravati",
      "description": "eTravo provides end-to-end corporate travel solutions in Amravati tailored to meet the dynamic mobility needs of modern businesses. From employee transportation and executive travel to client pickups and event logistics, we deliver seamless and scalable travel management. Our solutions combine reliability, comfort, and smart route planning, helping your company streamline travel while enhancing employee productivity and satisfaction."
    },
    {
      "name": "Hire Corporate Buses and Cabs in Amravati",
      "description": "Looking to hire corporate buses and cabs in Amravati? eTravo offers a wide fleet of air-conditioned vehicles including sedans, SUVs, tempo travellers, and large buses suitable for corporate mobility. Our services are ideal for daily staff commuting, corporate events, client travel, and more—delivered with flexible plans and round-the-clock support to ensure your business operations run smoothly."
    },
    {
      "name": "Business Transport Services Amravati",
      "description": "eTravo’s business transport services in Amravati are designed for small startups, large enterprises, and everything in between. Whether you need transport for routine employee movement or high-end executive travel, we provide customized transport plans. Our services include vehicle scheduling, route optimization, and transparent billing to help businesses enhance operational efficiency and reduce administrative load."
    },
    {
      "name": "Employee Transportation in Amravati",
      "description": "Simplify your organization’s daily travel needs with eTravo’s dedicated employee transportation services in Amravati. We provide punctual, safe, and efficient pickup and drop services that are tailored to shift timings and company locations. With trained drivers, real-time tracking, and a strong focus on commuter safety, we help your workforce travel stress-free every day."
    },
    {
      "name": "AC Cab Services for Companies in Amravati",
      "description": "Experience reliable and comfortable travel for your employees and clients with eTravo’s AC cab services for companies in Amravati. Our fully air-conditioned cabs ensure a pleasant commute even during peak summers. Whether for routine employee commutes, airport transfers, or executive meetings, our well-maintained vehicles and professional drivers ensure a premium service experience."
    },
    {
      "name": "Corporate Bus on Rent Amravati",
      "description": "eTravo offers well-equipped corporate buses on rent in Amravati for large-group employee transport, company events, offsites, and training programs. Our buses come with ample seating, AC, and GPS tracking, making them ideal for both short and long distances. We offer flexible rental plans—hourly, daily, or monthly—depending on your business needs."
    },
    {
      "name": "Office Shuttle Service in Amravati",
      "description": "Enhance employee satisfaction and punctuality with eTravo’s office shuttle service in Amravati. We provide professionally managed shuttle routes covering major residential and business hubs, ensuring seamless employee mobility. Our services come with route customization, dedicated vehicle allocation, and active customer support to optimize your office travel operations."
    },
    {
      "name": "Cost-Effective Staff Commute in Amravati",
      "description": "eTravo delivers cost-effective staff commute solutions in Amravati that don’t compromise on quality or safety. Designed for businesses looking to minimize travel budgets without affecting service standards, our plans include transport models, route consolidation, and efficient fleet allocation—helping your company save while offering dependable employee transport."
    }
  ],
  "tableData": [
    ["Corporate Travel Solutions Amravati", "Hire Corporate Buses and Cabs in Amravati"],
    ["Business Transport Services Amravati", "Employee Transportation in Amravati"],
    ["AC Cab Services for Companies in Amravati", "Corporate Bus on Rent Amravati"],
    ["Office Shuttle Service in Amravati", "Cost-Effective Staff Commute in Amravati"]
  ],







   "whychoose": [
    {
        "WhyChooseheading": "Punctual and Dependable Services",
        "WhyChoosedescription": "eTravo ensures timely and reliable corporate cab and bus services in Amravati. We help businesses maintain productivity by getting employees and executives to their destinations on schedule, every time."
    },
    {
        "WhyChooseheading": "Versatile Fleet for Corporate Needs",
        "WhyChoosedescription": "From premium cabs for executives to spacious buses for team transportation, our fleet in Amravati is designed to meet the diverse requirements of corporate clients—combining comfort, style, and efficiency."
    },
    {
        "WhyChooseheading": "Trained and Professional Drivers",
        "WhyChoosedescription": "Our drivers are experienced, well-trained, and follow professional standards suited for corporate transport. They know the best routes in and around Amravati, ensuring safe and seamless journeys."
    },
    {
        "WhyChooseheading": "Transparent and Affordable Rates",
        "WhyChoosedescription": "With eTravo, you get clear and competitive pricing. We provide detailed cost breakdowns with no hidden charges, allowing businesses in Amravati to plan transport budgets confidently."
    },
    {
        "WhyChooseheading": "Safety-Focused Travel Experience",
        "WhyChoosedescription": "All eTravo vehicles are equipped with safety essentials such as GPS tracking, first-aid kits, fire extinguishers, and seat belts. We prioritize the well-being of your employees during every trip."
    },
    {
        "WhyChooseheading": "24/7 Operational Support",
        "WhyChoosedescription": "Our services are available around the clock in Amravati. Whether you need early morning pickups, late-night returns, or last-minute changes, eTravo is ready to support your business logistics."
    },
    {
        "WhyChooseheading": "Simple and Flexible Booking",
        "WhyChoosedescription": "Booking corporate transport in Amravati is effortless with eTravo. Use our online platform or reach out to our dedicated support team for quick and flexible scheduling options."
    },
    {
        "WhyChooseheading": "Tailor-Made Corporate Travel Solutions",
        "WhyChoosedescription": "eTravo offers customized cab and bus packages for Amravati-based companies—perfect for daily commutes, off-site meetings, team outings, and corporate events. We adjust to your specific needs."
    }
]



















    }


   


const faqData = [
    [
        {
            question: 'What types of corporate cab and bus services does eTravo offer in Amravati?',
            answer: 'eTravo provides comprehensive corporate transportation in Amravati, including daily cab services for executives, staff bus transport, corporate event travel, and customized transport solutions for companies.',
        },
        {
            question: 'Is daily employee transportation available through eTravo in Amravati?',
            answer: 'Yes, we offer reliable and scheduled cab and bus services for employee commutes. Routes and schedules are customized based on your company’s shift timings and location needs.',
        },
        {
            question: 'Are your vehicles suitable for large teams or group travel?',
            answer: 'Definitely. eTravo operates everything from premium cabs for executives to large AC buses for teams, all maintained to deliver comfort, safety, and punctuality.',
        },
        {
            question: 'How does eTravo ensure safety and monitoring for corporate clients?',
            answer: 'Our entire fleet is GPS-enabled with 24/7 monitoring. Clients get access to live tracking and daily usage reports to ensure transparency and control over employee transportation.',
        },
        {
            question: 'Can we book eTravo for corporate events or business meetings in Amravati?',
            answer: 'Yes, we provide flexible one-time or multi-day bookings for corporate events, conferences, and business travel needs. All bookings are handled professionally with priority on punctuality and presentation.',
        },
        {
            question: 'Does eTravo offer account management and support for Amravati-based companies?',
            answer: 'Absolutely. We assign dedicated account managers to each corporate client in Amravati to manage logistics, updates, and any transport-related queries promptly.',
        },
    ]
];

const testimonialsData = [
    {
        name: 'Mr. Nitin Kale',
        designation: 'Admin Lead, BrightCode Solutions',
        rating: [1, 1, 1, 1, 1],
        text: '“eTravo’s corporate cab and bus services in Amravati have helped us streamline daily employee commutes. Their support team is proactive and service quality is top-notch.”',
    },
    {
        name: 'Ms. Anjali Tiwari',
        designation: 'HR Executive, StratEdge Technologies',
        rating: [1, 1, 1, 1, 1],
        text: '“Managing transport logistics used to be a hassle, but eTravo has made it completely worry-free. The vehicles are clean, always on time, and perfect for our corporate needs in Amravati.”',
    },
];




















    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9356411908",
            "+91 8600135991",

        ],
        email: "booking@etravo.in"
    };


    const Images = [
    {
        place: "/images/keyword/1.png",
        text: "Corporate Bus Services Pune",
        link: "/Corporate-Bus-Services-Pune"
    },
    {
        place: "/images/keyword/2.png",
        text: " Corporate Cab and Bus Service in Ahmednagar",
        link: "/Corporate-Cab-and-Bus-Service-in-Ahmednagar"
    },
    {
        place: "/images/keyword/3.png",
        text: " Corporate Cab and Bus Service in Amravati",
        link: "/Corporate-Cab-and-Bus-Service-in-Amravati"
    },
    {
        place: "/images/keyword/4.png",
        text: " Corporate Cab and Bus Service in Kolhapur",
        link: "/Corporate-Cab-and-Bus-Service-in-Kolhapur"
    },
    {
        place: "/images/keyword/5.png",
        text: " Corporate Cab and Bus Service in Sangli",
        link: "/Corporate-Cab-and-Bus-Service-in-Sangli"
    },
    {
        place: "/images/keyword/6.png",
        text: " Corporate Cab and Bus Service in Satara",
        link: "/Corporate-Cab-and-Bus-Service-in-Satara"
    },
    {
        place: "/images/keyword/7.png",
        text: " Corporate Cab and Bus Services for Outstation",
        link: "/Corporate-Cab-and-Bus-Services-for-Outstation"
    },
    {
        place: "/images/keyword/8.png",
        text: " Corporate Cab and Bus Services in Aundh",
        link: "/Corporate-Cab-and-Bus-Services-in-Aundh"
    },
    {
        place: "/images/keyword/9.png",
        text: " Corporate Cab and Bus Services in Aurangabad",
        link: "/Corporate-Cab-and-Bus-Services-in-Aurangabad"
    },
    {
        place: "/images/keyword/10.png",
        text: " Corporate Cab and Bus Services in Bhosari MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Bhosari-MIDC"
    },
    {
        place: "/images/keyword/11.png",
        text: " Corporate Cab and Bus Services in Hadapsar",
        link: "/Corporate-Cab-and-Bus-Services-in-Hadapsar"
    },
    {
        place: "/images/keyword/12.png",
        text: " Corporate Cab and Bus Services in Hinjewadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Hinjewadi"
    },
    {
        place: "/images/keyword/13.png",
        text: " Cab Services For corporate Travellers in Mumbai",
        link: "/Cab-Services-For-corporate-Travellers-in-Mumbai"
    },
    {
        place: "/images/keyword/14.png",
        text: " Corporate Cab and Bus Services in Nashik",
        link: "/Corporate-Cab-and-Bus-Services-in-Nashik"
    },
    {
        place: "/images/keyword/15.png",
        text: "Corporate Cab and Bus Services in Pune",
        link: "/Corporate-Cab-and-Bus-Services-in-Pune"
    },
    {
        place: "/images/keyword/16.png",
        text: "Corporate Cab and Bus Services in Sanaswadi",
        link: "/Corporate-Cab-and-Bus-Services-in-Sanaswadi"
    },
    {
        place: "/images/keyword/17.png",
        text: " Corporate Cab and Bus Services in Shirwal MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Shirwal-MIDC"
    },
    {
        place: "/images/keyword/18.png",
        text: " Corporate Cab and Bus Services in Solapur",
        link: "/Corporate-Cab-and-Bus-Services-in-Solapur"
    },
    {
        place: "/images/keyword/19.png",
        text: " Corporate Cab and Bus Services in Talwade MIDC",
        link: "/Corporate-Cab-and-Bus-Services-in-Talwade-MIDC"
    },
    {
        place: "/images/keyword/20.png",
        text: "  Corporate Cab and Bus Services Pune Airport",
        link: "/Corporate-Cab-and-Bus-Services-Pune-Airport"
    },
    {
        place: "/images/keyword/21.png",
        text: " Corporate Cabs and Bus in Ranjangaon MIDC",
        link: "/Corporate-Cabs-and-Bus-in-Ranjangaon-MIDC"
    },
    {
        place: "/images/keyword/22.png",
        text: " Corporate Cabs and Bus Services in Chakan",
        link: "/Corporate-Cabs-and-Bus-Services-in-Chakan"
    },
    {
        place: "/images/keyword/23.png",
        text: " Corporate Cabs and Bus Services in Nagpur",
        link: "/Corporate-Cabs-and-Bus-Services-in-Nagpur"
    },
    {
        place: "/images/keyword/24.png",
        text: "  One Way Cab Services Mumbai to Pune Drop",
        link: "/One-Way-Cab-Services-Mumbai-to-Pune-Drop"
    },
];



    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];





const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab and Bus Service in Amravati",
  "image": "https://www.etravo.in/images/keyword/corporate-cab-bus-service-amravati.jpg",
  "description": "Get dependable and affordable Corporate Cab and Bus Services in Amravati with eTravo. We offer business travel solutions, office shuttle services, and staff commute options with AC cabs and buses. Ideal for daily employee transportation and corporate events.",
  "brand": {
    "@type": "Brand",
    "name": "eTravo"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "3850"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2199",
    "availability": "https://schema.org/InStock",
    "url": "https://www.etravo.in/corporate-cab-and-bus-service-in-amravati"
  }
};






    return (
        <div>

<Helmet>
  <title>Corporate Cab and Bus Service in Amravati | Staff Commute & Business Travel | eTravo</title>
  <meta 
    name="description" 
    content="Hire corporate cab and bus service in Amravati from eTravo for cost-effective staff transport and business travel. AC buses and cabs with reliable service for daily commute and events." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section
                className="page-title"
                style={{ backgroundImage: 'url(images/background/3.jpg)' }}
            >
                <div className="auto-container">
                    <h1>{cardData.keyword}</h1>
                    <div className="bread-crumb-outer">

                    </div>
                </div>
            </section>




            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/3.png' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#008000', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For eTravo</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />

                                                
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e, index) => (
    <div className="box1 d-flex justify-content-around align-items-center" key={index}>
        <div className="b1">
            <a href={e.link}>
                <img src={e.place} alt={e.text.trim()} />
            </a>
        </div>
        <div className="b2 px-3">
            <a href={e.link} >
                {e.text.trim()}
            </a>
        </div>
    </div>
))}


                            <div className="gallery-container">
                               <h2 className="gallery-title d-none">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #008000',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#008000' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919356411908" className="d-block  text-white">+91 9356411908</a>
                                                <a href="tel:+918600135991" className="d-block  text-white">+91 8600135991</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@etravo.in" className=" text-white d-block">
                                                    booking@etravo.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#008000' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> etravo  <br />
                                                       Office No.231 & 232 Ganesh Galaxy Near Ashoka Hotel Alandi Pune road wadhmukhwadi - 412105
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Coproratecabandbusserviceinamravati;